import { FC, useState } from "react";
import FullScreenDialog from "../FullScreenDialog";
import { Box, IconButton } from "@mui/material";
import {
  Bookmark,
  BookmarkBorderOutlined,
  History,
  QrCode,
} from "@mui/icons-material";
import GameEventLog from "./GameEventLog";
import { BookmarksQrCode } from "./BookmarksQrCode";
import ActionButton from "../buttons/ActionButton";

const GameEventLogDialog: FC<{
  showFilterButton?: boolean;
}> = ({ showFilterButton }) => {
  const [eventHistoryOpen, setEventHistoryOpen] = useState(false);
  const [qrCodeDialogOpen, setQrCodeDialogOpen] = useState(false);
  const [isFilterActive, setIsFilterActive] = useState(false);

  const openGameEventLog = () => {
    setEventHistoryOpen(true);
  };

  const closeGameEventLog = () => {
    setEventHistoryOpen(false);
  };

  return (
    <>
      <FullScreenDialog
        show={eventHistoryOpen}
        handleClose={closeGameEventLog}
        title={"Ticker Nachrichten"}
        button={
          <Box display="flex" alignItems="center" gap={"2vw"}>
            {showFilterButton && (
              <IconButton
                color="inherit"
                onClick={() => setIsFilterActive(!isFilterActive)}
              >
                {isFilterActive ? <Bookmark /> : <BookmarkBorderOutlined />}
              </IconButton>
            )}
            <IconButton
              color="inherit"
              onClick={() => setQrCodeDialogOpen(true)}
            >
              <QrCode />
            </IconButton>
          </Box>
        }
      >
        <GameEventLog filterBookmarks={isFilterActive} />
      </FullScreenDialog>

      <BookmarksQrCode
        isOpen={qrCodeDialogOpen}
        onClose={() => setQrCodeDialogOpen(false)}
      />

      <ActionButton label={"Historie"} onClick={openGameEventLog}>
        <History />
      </ActionButton>
    </>
  );
};

export default GameEventLogDialog;
